<template>
    <div class="hello">
        <h3 v-on:click="return_to_cats()">Brands & Product Names containing "{{ keyword }}"</h3>
        <section v-if="errored">
            <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
        </section>
        <div v-if="loading" class="loading">
            <div class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>

        <div id='resulttarget' v-if="(showBrandProducts && !loading)" class="productResults clearfix">
            <div class="resultsblock">
                <Pager v-if="(meta != null)" v-bind:meta="meta" @previous="previous_page()" @next="next_page()" v-bind:page="page"/>
                <BrandWithProducts
                        v-for="brandproduct in processedBrandProducts" v-bind:key="brandproduct.id"
                        v-bind:brandproduct="brandproduct"
                        v-bind:keyword="keyword"
                />
                <Pager v-if="((meta != null) && (meta.total > 0))" v-bind:meta="meta" @previous="previous_page()" @next="next_page()" v-bind:page="page"/>
            </div>
        </div>
    </div>


</template>

<script>
    import BrandWithProducts from './BrandWithProducts.vue'
    import ApiService from '../services/ApiService';
    import Pager from './Pager.vue'

    export default {
        name: 'BrandsProductsByKeyword',
        components: {
            BrandWithProducts,
            Pager
        },
        props: {
            keyword:
                {
                    type: String,
                    default: ''
                }
        },
        event: 'update_keyword',
        data() {
            return {
                alphaselect: '',
                title: "Brands",
                brandProducts: [],
                info: null,
                loading: true,
                errored: false,
                showBrandProducts: true,
                page: 1,
                meta: null
            }
        },
        watch: {
            keyword: function () {
                this.loading = true;
                this.get_results();
            },
        },
        created() {
            // disabled. Hammering server.
            this.get_results();
        },
        mounted() {
        },
        methods: {
            get_results() {
                this.loading = true;
                console.log('get_results', this.keyword, this.page);
                ApiService.getBrandproductsByKeyword(this.keyword, this.page)
                    .then(response => (this.brandProducts = response.data))
                    .then(response => (this.meta = response.meta))
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => {
                        this.showBrandProducts = true;
                        this.loading = false;

                    })
            },
            previous_page() {
                this.page--;
                this.get_results();
            },
            next_page() {
                this.page++;
                this.get_results();
            }
        },
        computed: {
            processedBrandProducts() {
                if ('undefined' != this.brandProducts) {
                    let brandProducts = this.brandProducts.data;
                    // console.log('here', brandProducts);
                    return brandProducts;
                } else {
                    return [];
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        font-size: 24px;
        font-weight: 500;
        margin: 40px 0 0;
    }

    h5 a {
        color: #555;
    }


    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .alphabrandpager {
        text-align: center !important;
        padding: .5em 0;
    }
</style>
